@for (ratingId of ratingArr; track ratingId; let i = $index) {
  <mt-btn class="icon circle" [color]="color" class="mt-rating"
    [id]="'star_' + i" (onAction)="onClick(i + 1)" [matTooltip]="ratingId + 1" matTooltipPosition="above">
    <mat-icon>
      {{ showIcon(i) }}
    </mat-icon>
  </mt-btn>
}
